<template>
  <v-container>
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs" />
    </div>
    <div class="form-npa private-pg">
      <div class="position">
        <div class="bg-white p-20">
          <div class="form-head">
            <Widget position="menu_profile" />
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn dark v-on="on" class="navbar-toggler-profile" :aria-label="$t('Открыть меню профиля')">
                  {{ $t('Профиль') }} <span class="caret" aria-hidden="true"></span>
                </v-btn>
              </template>
              <v-list class="navbar-collapse">
                <v-list-item>
                  <Widget position="menu_profile" />
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="form-body">
            <div class="private-section">
              <v-simple-table v-if="items.length">
                <caption class="sr-only">{{ $t('Мои ответы') }}</caption>
                <thead>
                  <tr>
                    <th v-for="(value, field) in tableFields" :key="field" scope="col">
                      <a href="#" :aria-label="$t('Сортировать') + ': ' + value" @click.prevent="sortData(field)">
                        <i class="pro-icon-arrow-bottom1" aria-hidden="true"></i>
                        {{ value }}
                      </a>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="{ item, commentNpa, npaVersionBlock } in items"
                    :key="item.id"
                  >
                    <td>
                      <router-link
                        :title="item.text |strippedContent"
                        active-class="active"
                        :to="$i18nRoute({
                          name: 'view-npa',
                          params: { id: commentNpa.id },
                          query: { answer: item.id, block: npaVersionBlock }
                        })"
                        :key="item.id"
                      >
                        <div v-html="item.text"></div>
                      </router-link>
                    </td>
                    <td>
                      {{ new Date(item.created) | dateFormat('DD.MM.YYYY') }}
                    </td>
                    <td>
                      <router-link
                        :title="commentNpa.transProjectGoal | strippedContent"
                        active-class="active"
                        :to="$i18nRoute({
                          name: 'view-npa',
                          params: { id: commentNpa.id }
                        })"
                      >
                        {{ commentNpa.transName }}
                      </router-link>
                    </td>
                    <td>{{ commentNpa.view.transName }}</td>
                    <td>
                      <span
                        v-for="category in commentNpa.category"
                        :key="category.id"
                      >
                        {{ category.transName }},
                      </span>
                    </td>
                    <td>{{ item.status.transName }}</td>
                    <td>
                      {{
                        new Date(commentNpa.discussion_period_date_to)
                          | dateFormat('DD.MM.YYYY')
                      }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <div class="private-footer">
                <p>{{ $t('Общее количество') }}: {{ itemsTotal }}</p>
              </div>

              <v-pagination
                v-model="page"
                :length="pagesCount"
                :total-visible="7"
                :aria-label="$t('Страницы результатов поиска')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import Widget from '@/components/app/Widget'
import Npa from '@/model/npa'
import {Trans} from "@/plugins/Translation"

export default {
  components: {
    Widget
  },
  data: () => ({
    breadcrumbs: [],
    tableFields: {},
    items: [],
    sorting: {},
    sortSettings: {
      text: null,
      created: null,
      view: null,
      name: null,
      category: null,
      status: null,
      discussionPeriodDateTo: null
    },
    itemsTotal: 0,
    page: 1,
    pagesCount: 1
  }),
  watch: {
    $route: 'fetchData',
    page() {
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData() {
      this.setLoading(true)
      this.sorting.page = this.page
      Npa.getCommentAnswers(this.sorting)
        .then((response) => {
          this.items = response.items
          const paginator = response.paginationData
          this.itemsTotal = paginator.totalCount
          this.pagesCount = paginator.pageCount
          this.breadcrumbs = [
            {
              text: this.$i18n.t('Профиль'),
              disabled: false,
              href: Trans.currentLocaleUrl + '/profile'
            },
            { text: this.$i18n.t('Все мои ответы'), disabled: true }
          ]
          this.tableFields = {
            text: this.$i18n.t('Ответ'),
            created: this.$i18n.t('Дата'),
            view: this.$i18n.t('Вид проекта НПА'),
            name: this.$i18n.t('Наименование'),
            category: this.$i18n.t('Категории'),
            status: this.$i18n.t('Статус'),
            discussionPeriodDateTo: this.$i18n.t('Дата окончания обсуждения')
          }
          this.setLoading(false)
        })
        .catch((error) => {
          this.$router.push(Trans.i18nRoute({
            name: 'error',
            params: {
              status: error.response.status
            }
          }))
          this.setLoading(false)
        })
    },
    sortData(sortKey) {
      if (
        !this.sortSettings[sortKey] ||
        this.sortSettings[sortKey] === 'desc'
      ) {
        this.sortSettings[sortKey] = 'asc'
      } else {
        this.sortSettings[sortKey] = 'desc'
      }

      this.page = 1

      this.sorting = {
        page: this.page,
        orderBy: sortKey,
        orderDir: this.sortSettings[sortKey]
      }
      this.fetchData()
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
